// extracted by mini-css-extract-plugin
export var formInfo = "fy_MB";
export var formInfo__image = "fy_Mv";
export var formInfo__link = "fy_Mz";
export var formInfo__list = "fy_Mx";
export var formInfo__sectionHr = "fy_My";
export var formInfo__services = "fy_Mt";
export var formInfo__title = "fy_Mw";